import axios from 'axios'

import {ApiInstance} from './interfaces'

type Config = {
    baseURL?: string
}

export const getApiModule = () => {
    return axios
}

export const getApiInstance = ({defaultConfig}: {defaultConfig?: Config}): ApiInstance => {
    return getApiModule().create({...defaultConfig})
}
